import { Menu as BaseMenu } from 'antd';
import styled from 'styled-components';

export const Menu = styled(BaseMenu)`
  width: 270px;
  height: 100%;
  background-color: transparent !important;
  border: none !important;
  max-height: calc(100vh - 100px);
  overflow: auto;

  > .ant-menu-item {
    padding-left: 0px !important;
  }

  .ant-menu-sub {
    background-color: transparent !important;
    .ant-menu-item {
      padding-left: 24px !important;
    }
  }

  .ant-menu-submenu-title {
    padding-left: 0 !important;
  }
`;

export const MenuLabel = styled.div`
  white-space: nowrap;
  line-height: 400;
  color: #000;
  padding-left: 4px;
`;

export const SubMenuLabel = styled.div`
  color: #4A4A4A;
  white-space: nowrap;
`;
